import React, { useState, useEffect, useRef, useMemo } from 'react'
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../services/UserService';
import { addPedagogy, updatePedagogy } from '../../services/CourseService';
import { toast } from 'react-toastify';
import { getKc, updateKc, deleteKc, addKc } from '../../services/Kc';
import Swal from 'sweetalert2';
import Select from 'react-select';
import Loader from '../../utility/Loader';

export default function AddPedagogy() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [userDetails, setUserDetails] = useState({user: {first_name: ""}});
    const [selectedModule, setSelectedModule] = useState(0);
    const [seqNo, setSeqNo] = useState(0);
    const [edit, setEdit] = useState(false);
    const [pedagogy, setPedagogy] = useState({});
    const [assessments, setAssessments] = useState([]);
    const [level, setLevel] = useState([{label: "Beginner", value: "BEGINNER"},
        {label: "Intermediate", value: "INTERMEDIATE"},
        {label: "Advanced", value: "ADVANCED"},
        {label: "Expert", value: "EXPERT"}
    ])
    useEffect(() => {
        const userDetails = getUserDetails();
        if(userDetails.token === undefined){
            navigate('/login');
        }else{
            setUserDetails(userDetails);
            let moduleValue = sessionStorage.getItem('moduleValue') === null ? null : JSON.parse(sessionStorage.getItem('moduleValue'));
            if(moduleValue === null){
                navigate('/superadmin/managepedagogy');
                toast.warning("Please choose a course and module!");
            }else{
                setSelectedModule(moduleValue);
                //sessionStorage.removeItem('moduleValue');
            }
            let pedagogyEdit = sessionStorage.getItem('pedagogyEdit') === null ? null : JSON.parse(sessionStorage.getItem('pedagogyEdit'));
            
            if(pedagogyEdit !== null){
                setPedagogy(pedagogyEdit);
                if(pedagogyEdit.pedagogy_type === 'ASSESSMENT' && pedagogyEdit.id !== undefined && pedagogyEdit.id !== null){
                    getAssessmentData(pedagogyEdit.id);
                }
                setEdit(true);
                sessionStorage.removeItem("pedagogyEdit");
            }else{
                setEdit(false);
            }


        }
    },[]);
    

    const handleValueChange = (e) => {
        const { name, value } = e.target;
        setPedagogy({
          ...pedagogy,
          [name]: value,
        });
    };

    const handleAssessmentValueChange = (value, field, index) => {
        const updated = [...assessments];
        updated[index] = {
              ...updated[index],
              [field]: value
        };
          
        if(field === "type"){
            if(value === "TRUE_FALSE"){
                updated[index] = {
                    ...updated[index],
                    ["option1"]: "True",
                    ["option2"]: "False",
                    ["option3"]: null,
                    ["option4"]: null,
                    ["option5"]: null,
              };

            }
            if(value === "YES_NO"){
                updated[index] = {
                    ...updated[index],
                    ["option1"]: "Yes",
                    ["option2"]: "No",
                    ["option3"]: null,
                    ["option4"]: null,
                    ["option5"]: null,
              };
            }
        }
        setAssessments(updated);
    };

    const addAssessmentData = async (status, index) => {
        if(assessments[index]["id"] !== undefined && assessments[index]["id"] !== null){
            const obj = {
                module_id: selectedModule.module_id,
                course_id: selectedModule.course_id,
                pedagogy_id: pedagogy.id,
                primary_text: assessments[index]["primary_text"],
                secondary_text: "",
                option1: assessments[index]["option1"],
                option2: assessments[index]["option2"],
                option3: assessments[index]["option3"],
                option4: assessments[index]["option4"],
                option5: assessments[index]["option5"],
                id: assessments[index]["id"],
                correct_option_no: assessments[index]["correct_option_no"],
                type: assessments[index]["type"],
                seq_no: index+1,
                status: status
            }
            let resp = await updateKc(userDetails.token, obj);
            if(resp.error === false){
                toast.success("Assessment Updated!");
                const updated = [...assessments];
                updated[index] = {
                    ...updated[index],
                    ["id"]: resp.kc_id
                };
                setAssessments(updated);
    
            }else{
                toast.error("Some Error occurred while adding assessment!");
            }

            
        }else{
            const obj = {
                module_id: selectedModule.module_id,
                course_id: selectedModule.course_id,
                pedagogy_id: pedagogy.id,
                primary_text: assessments[index]["primary_text"],
                secondary_text: "",
                option1: assessments[index]["option1"],
                option2: assessments[index]["option2"],
                option3: assessments[index]["option3"],
                option4: assessments[index]["option4"],
                option5: assessments[index]["option5"],
                correct_option_no: assessments[index]["correct_option_no"],
                type: assessments[index]["type"],
                seq_no: index+1,
                status: status
            }
            let resp = await addKc(userDetails.token, obj);
            if(resp.error === false){
                toast.success("Assessment added!");
                const updated = [...assessments];
                updated[index] = {
                    ...updated[index],
                    ["id"]: resp.kc_id
                };
                setAssessments(updated);
    
            }else{
                toast.error("Some Error occurred while adding assessment!");
            }
        }
        

    };

    const deleteAssessment = async (index) => {
        setLoading(true);
        let resp = await  deleteKc(userDetails.token, assessments[index]["id"]);
        if(resp.error === false){
            toast.success("Assessment deleted successfully!");
            await getAssessmentData(pedagogy.id);
        }else{
            toast.error("Some error occurred!")
        }
        setLoading(false);
    };

    const getAssessmentData = async (pedagogy_id) => {
        const usrDtl = getUserDetails();
        let resp = await getKc(usrDtl.token, pedagogy_id);
        if(resp.error === false){
            
            setAssessments(resp.data);

        }

    };

    const questionRefs = useRef([]);
    const addNewAssessment = async () => {
        let newAssessment = {
            type: 'MCQ',
          };
          setAssessments(prevAssessments => [...prevAssessments, newAssessment]);
          setTimeout(() => {
            const lastIndex = assessments.length; // next index
            const lastRef = questionRefs.current[lastIndex];
            if (lastRef) {
                lastRef.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    };

    const handleCodeChange = (code) => {
        setPedagogy({
          ...pedagogy,
          ["pedagogy_type"]: code,
        });
    };

    const handleLevelChange = (lvl) => {
        setPedagogy({
          ...pedagogy,
          ["level"]: lvl,
        });
    };

    const validatePedagogy = (pedagogy) => {
        if(pedagogy.pedagogy_type === undefined || pedagogy.pedagogy_type === null || pedagogy.pedagogy_type === ''
            || pedagogy.module_id === undefined || pedagogy.module_id === null || pedagogy.module_id === ''
            || pedagogy.course_id === undefined || pedagogy.course_id === null || pedagogy.course_id === ''
            || pedagogy.time_in_sec < 0

        ){
            return false;
        }
        return true;
    };
    const addQuestionRef = useRef(null);
    const addPedagogyData = async (type) => {
        let objectToPost = Object.assign(pedagogy);
        pedagogy["module_id"] = selectedModule.module_id;
        pedagogy["course_id"] = selectedModule.course_id;
        if(objectToPost.url === undefined){
            objectToPost.url = null;
        }
        if(objectToPost.embed_code === undefined){
            objectToPost.embed_code = null;
        }
        if(objectToPost.json_data === undefined){
            objectToPost.json_data = null;
        } 
        if(objectToPost.pedagogy_seq_no === undefined){
            objectToPost.pedagogy_seq_no = 1;
        }           
        objectToPost["pedagogy_status"] = type;
        
        setLoading(true);
        if(validatePedagogy(objectToPost)){
            if(edit === false && pedagogy.id === undefined){
                let resp = await addPedagogy(userDetails.token, objectToPost);
                if(resp.error === false){
                    toast.success("Pedagogy added successfully!");
                    if(pedagogy.pedagogy_type !== 'ASSESSMENT'){
                        setPedagogy({});
                    }else{
                        setPedagogy({
                            ...pedagogy,
                            ["id"]: resp.pedagogy_id,
                        });
                    }
                    setEdit(false);
                    // ✅ Scroll to Add Question only after PUBLISH
                    if (type === "PUBLISHED" && pedagogy.pedagogy_type === "ASSESSMENT") {
                        sessionStorage.setItem("scrollToAddQuestion", "true");
                    }                      
                }else{
                    toast.error("Some error occurred while adding pedagogy!")
                }
            }else{
                objectToPost["pedagogy_id"] = objectToPost["id"];
                let resp = await updatePedagogy(userDetails.token, objectToPost);
                if(resp.error === false){
                    toast.success("Pedagogy updated successfully!")
                    setPedagogy({});
                    setEdit(false);
                    navigate('/superadmin/managepedagogy');
                }else{
                    toast.error("Some error occurred while adding pedagogy!")
                }
            }
            
        }else{
            toast.warning("Some required field is missing!");
        }
        setLoading(false);

    };
    useEffect(() => {
        const shouldScroll = sessionStorage.getItem("scrollToAddQuestion");
        if (
            shouldScroll === "true" &&
            pedagogy.pedagogy_type === 'ASSESSMENT' &&
            pedagogy.id !== undefined &&
            addQuestionRef.current
        ) {
            addQuestionRef.current.scrollIntoView({ behavior: "smooth" });
            sessionStorage.removeItem("scrollToAddQuestion");
        }
    }, [pedagogy]); // Runs again when pedagogy updates

    return (
        <div>
            {loading ? (
                <Loader />
            ) : (
                <div className=''>
                    <h3 className='text-2xl text-secondary inter-700 mt-6 mb-6 md:mb-4 lg:mb-3 lg:hidden'>{edit? "Update Pedagogy" : "Add New Pedagogy"}</h3>
                    <form>
                        <div className='pt-10 lg:px-12 px-6 pb-4 bg-[#FDF8F8] border-b border-[#D9D9D9]'>
                            <div className='back-btn flex justify-start mb-5 md:mb-8'>
                                <a onClick={() => navigate('/superadmin/managepedagogy')} className='cursor-pointer w-auto bg-tertiary hover:bg-black flex items-center justify-center px-6 h-7 2xl:h-8 text-white inter-500 text-xs 2xl:text-lg rounded-3xl lg:rounded-full transition duration-300 button-shadow'>Back</a>
                            </div>
                            <div className='flex flex-wrap mb-4 md:mb-0'>
                                <div className='w-full md:w-1/5'>
                                    <p className='text-xl text-[#9E9E9E] inter-700 mb-2'>Technology</p>
                                </div>
                                <div className='w-full md:w-4/5'>
                                    <p className='text-xl text-[#9E9E9E] inter-700 mb-2'>{selectedModule.course_name}</p>
                                </div>
                            </div>
                            <div className='flex flex-wrap'>
                                <div className='w-1/2 md:w-1/5'>
                                    <p className='text-base text-[#9E9E9E] inter-400 mb-2'>Module No.</p>
                                </div>
                                <div className='w-1/2 md:w-1/5'>
                                    <p className='text-base text-[#9E9E9E] inter-400 mb-2'>{selectedModule.module_seq_no}</p>
                                </div>
                            </div>
                            <div className='flex flex-wrap'>
                                <div className='w-1/2 md:w-1/5'>
                                    <p className='text-base text-[#9E9E9E] inter-400 mb-2'>Module </p>
                                </div>
                                <div className='w-1/2 md:w-1/5'>
                                    <p className='text-base text-[#9E9E9E] inter-400 mb-1'>{selectedModule.module_code + " - " + selectedModule.module_name}</p>
                                    {/* Add module type according to selection */}
                                    {/* <p className='text-base text-[#9E9E9E] inter-400 mb-1'>Text 01</p> */}
                                </div>
                            </div>
                        </div>
                        <div className='lg:px-12 px-6 pb-6 md:pb-10'>
                            <div className='pt-10 pb-2'>
                                <p className='text-xl 2xl:text-2xl text-black inter-400 mb-6'>What do you want to add?</p>
                                <div className='flex items-center flex-wrap w-2/3'>
                                    <div className='customer-radio-sngl w-full md:w-1/2 md:pr-3 mb-5 md:mb-8'>
                                        <input type="radio" id="preassessment" name="radio-group" value="TEXT" checked={pedagogy.pedagogy_type === "TEXT"} onChange={() => handleCodeChange("TEXT")} />
                                        <label htmlFor="preassessment" className=''>Text/Content</label>
                                    </div>
                                    <div className='customer-radio-sngl w-full md:w-1/2 md:pr-3 mb-5 md:mb-8'>
                                        <input type="radio" id="theory" name="radio-group" value="IMAGE" checked={pedagogy.pedagogy_type === "IMAGE"} onChange={() => handleCodeChange("IMAGE")} />
                                        <label htmlFor="theory">Images/animations</label>
                                    </div>
                                    <div className='customer-radio-sngl w-full md:w-1/2 md:pr-3 mb-5 md:mb-8'>
                                        <input type="radio" id="application" name="radio-group" value="VIDEO" checked={pedagogy.pedagogy_type === "VIDEO"} onChange={() => handleCodeChange("VIDEO")} />
                                        <label htmlFor="application">Video</label>
                                    </div>
                                    <div className='customer-radio-sngl w-full md:w-1/2 md:pr-3 mb-5 md:mb-8'>
                                        <input type="radio" id="component" name="radio-group" value="AUDIO" checked={pedagogy.pedagogy_type === "AUDIO"} onChange={() => handleCodeChange("AUDIO")} />
                                        <label htmlFor="component">Audio</label>
                                    </div>
                                    <div className='customer-radio-sngl w-full md:w-1/2 md:pr-3 mb-5 md:mb-8'>
                                        <input type="radio" id="taxonomy" name="radio-group" value="ASSESSMENT" checked={pedagogy.pedagogy_type === "ASSESSMENT"} onChange={() => handleCodeChange("ASSESSMENT")} />
                                        <label htmlFor="taxonomy">Test/Quiz</label>
                                    </div>
                                    <div className='customer-radio-sngl w-full md:w-1/2 md:pr-3 mb-5 md:mb-8'>
                                        <input type="radio" id="schematics" name="radio-group" value="GAME" checked={pedagogy.pedagogy_type === "GAME"} onChange={() => handleCodeChange("GAME")} />
                                        <label htmlFor="schematics">Games</label>
                                    </div>
                                    <div className='customer-radio-sngl w-full md:w-1/2 md:pr-3 mb-5 md:mb-8'>
                                        <input type="radio" id="chain" name="radio-group" value="SIMULATION" checked={pedagogy.pedagogy_type === "SIMULATION"} onChange={() => handleCodeChange("SIMULATION")} />
                                        <label htmlFor="chain">Simulations</label>
                                    </div>
                                    <div className='customer-radio-sngl w-full md:w-1/2 md:pr-3 mb-5 md:mb-8'>
                                        <input type="radio" id="h5p" name="radio-group" value="QBOT" checked={pedagogy.pedagogy_type === "H5P"} onChange={() => handleCodeChange("H5P")} />
                                        <label htmlFor="h5p">Interactive</label>
                                    </div>
                                </div>
                                <div className='w-full md:w-1/4 md:mt-8 mt-6 md:mr-6 mb-4 md:mb-8'>
                                    <label className='text-base md:text-lg text-[#6F7482] inter-400'>Choose Level</label>
                                    <Select placeholder="Select Level" className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md relative z-10'
                                        options={level}
                                        value={level.find(option => option.value === pedagogy.level)}
                                        onChange={(values) => handleLevelChange(values.value)}
                                    />
                                </div>
                                <div className='w-full md:w-2/4  md:mr-6 mb-4 md:mb-0'>
                                    <label className='text-base md:text-lg text-[#6F7482] inter-400'>Tags</label>
                                    <textarea type='text' name="tags" value={pedagogy.tags} onChange={handleValueChange} placeholder='Enter tags here... ' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-40 2xl:h-56 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                                    <p className='text-sm text-[#6F7482]'>Seperate multi tags with "commas (,)"</p>
                                </div>
                            </div>
                        </div>
                        <div className='lg:px-12 px-6 pb-10'>
                            <div className='md:pt-2 pb-2'>
                                <div>       
                                    <div className='form-field w-full lg:w-3/4 mb-4'>
                                        <label className='text-base md:text-lg text-[#6F7482] inter-400'>Learning Time (In Seconds)</label>
                                        <input type='number' name="time_in_sec" value={pedagogy.time_in_sec} onChange={handleValueChange} placeholder='Enter Learning time in seconds' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                    </div>
                                    
                                </div>
                                {pedagogy.pedagogy_type === 'TEXT'? (
                                    <div>
                                        <div className='form-field w-full lg:w-3/4 mb-4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Title of Text</label>
                                            <input type='text' name="title" value={pedagogy.title} onChange={handleValueChange} placeholder='Enter title here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                        <div className='form-field w-full lg:w-3/4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Text Content</label>
                                            <textarea type='text' name="text" value={pedagogy.text} onChange={handleValueChange} placeholder='Enter content here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-40 2xl:h-56 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                    </div>
                                ): (
                                    null
                                )}
                                {pedagogy.pedagogy_type === 'IMAGE'? (
                                    <div>
                                        <div className='form-field w-full lg:w-3/4 mb-4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Title of Image</label>
                                            <input type='text' name='title' value={pedagogy.title} onChange={handleValueChange} placeholder='Enter title here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                        <div className='form-field w-full lg:w-3/4 mb-4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Image URL</label>
                                            <input type='text' name='url' value={pedagogy.url} onChange={handleValueChange} placeholder='Enter URL here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                        <div className='form-field w-full lg:w-3/4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Image Content</label>
                                            <textarea type='text' name='text' value={pedagogy.text} onChange={handleValueChange} placeholder='Enter content here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-40 2xl:h-56 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                    </div>
                                ): (
                                    null
                                )}
                                {pedagogy.pedagogy_type === 'VIDEO'? (
                                    <div>
                                        <div className='form-field w-full lg:w-3/4 mb-4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Title of Video</label>
                                            <input type='text' name="title" value={pedagogy.title} onChange={handleValueChange} placeholder='Enter title here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                        <div className='form-field w-full lg:w-3/4 mb-4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Video URL</label>
                                            <input type='text' name="url" value={pedagogy.url} onChange={handleValueChange} placeholder='Enter URL here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                        
                                        <div className='form-field w-full lg:w-3/4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Video Content</label>
                                            <textarea type='text' name="text" value={pedagogy.text} onChange={handleValueChange} placeholder='Enter content here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-40 2xl:h-56 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                    </div>
                                ): (
                                    null
                                )}
                                {pedagogy.pedagogy_type === 'AUDIO'? (
                                    <div>
                                        <div className='form-field w-full lg:w-3/4 mb-4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Title of Audio</label>
                                            <input type='text' name="title" value={pedagogy.title} onChange={handleValueChange} placeholder='Enter title here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                        <div className='form-field w-full lg:w-3/4 mb-4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Audio URL</label>
                                            <input type='text' name="url" value={pedagogy.url} onChange={handleValueChange} placeholder='Enter URL here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                        <div className='form-field w-full lg:w-3/4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Audio Content</label>
                                            <textarea type='text' name="text" value={pedagogy.text} onChange={handleValueChange} placeholder='Enter content here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-40 2xl:h-56 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                    </div>
                                ): (
                                    null
                                )}
                                {pedagogy.pedagogy_type === 'SIMULATION'? (
                                    <div>
                                        <div className='form-field w-full lg:w-3/4 mb-4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Title of Simulation</label>
                                            <input type='text' name="title" value={pedagogy.title} onChange={handleValueChange} placeholder='Enter title here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                        <div className='form-field w-full lg:w-3/4 mb-4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Simulation URL</label>
                                            <input type='text' name="url" value={pedagogy.url} onChange={handleValueChange} placeholder='Enter URL here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                        <div className='form-field w-full lg:w-3/4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Simulation Content</label>
                                            <textarea type='text' name="text" value={pedagogy.text} onChange={handleValueChange} placeholder='Enter content here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-40 2xl:h-56 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                    </div>
                                ): (
                                    null
                                )}
                                {pedagogy.pedagogy_type === 'GAME'? (
                                    <div>
                                        <div className='form-field w-full lg:w-3/4 mb-4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Title of Game</label>
                                            <input type='text' name="title" value={pedagogy.title} onChange={handleValueChange} placeholder='Enter title here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                        <div className='form-field w-full lg:w-3/4 mb-4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Game URL</label>
                                            <input type='text' name="url" value={pedagogy.url} onChange={handleValueChange} placeholder='Enter URL here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                        <div className='form-field w-full lg:w-3/4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Game Content</label>
                                            <textarea type='text' name="text" value={pedagogy.text} onChange={handleValueChange} placeholder='Enter content here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-40 2xl:h-56 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                    </div>
                                ): (
                                    null
                                )}
                                {pedagogy.pedagogy_type === 'ASSESSMENT' ? (
                                    <div>
                                        <div className='form-field w-full lg:w-3/4 mb-4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Title of Test</label>
                                            <input type='text' name="title" value={pedagogy.title} onChange={handleValueChange} placeholder='Enter title here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div>
                                        
                                        
                                        {/* <div className='form-field w-full lg:w-3/4'>
                                            <label className='text-base md:text-lg text-[#6F7482] inter-400'>Description</label>
                                            <textarea type='text' name="text" value={pedagogy.text} onChange={handleValueChange} placeholder='Enter content here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-40 2xl:h-56 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                        </div> */}
                                    </div>
                                    
                                ): (
                                    null
                                )}
                                
                                {pedagogy.pedagogy_type !== undefined ? (
                                    <div className='flex flex-wrap justify-between mt-12 lg:w-3/4'>
                                        <div className='w-full md:w-2/5'>
                                            <button type="button" onClick={() => addPedagogyData("DRAFT")} className='w-full bg-secondary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow mb-5 md:mb-10'>+ Save in Draft</button>
                                        </div>
                                        <div className='w-full md:w-2/5'>
                                            <button type="button" onClick={() => addPedagogyData("PUBLISHED")} className='w-full bg-tertiary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow mb-5 md:mb-10'>+ Publish</button>
                                        </div>
                                    </div>
                                ) : (
                                    null
                                )}
                                {pedagogy.pedagogy_type === 'ASSESSMENT' && pedagogy.id !== undefined && pedagogy.id !== null ? (
                                    <>

                                        <div ref={addQuestionRef} className='flex flex-wrap justify-between mt-12 lg:w-3/4'>
                                            <div className='w-full md:w-2/5'>
                                                <button type="button" onClick={() => addNewAssessment()} className='w-full bg-secondary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow mb-5 md:mb-10'>Add Question</button>
                                            </div>
                                            
                                        </div>
                                        {assessments.map((assessment, index) => (
                                            <div key={index} ref={(el) => (questionRefs.current[index] = el)}>
                                                <div className='lg:px-12 px-6 pb-10'>
                                                    <div className='pt-10 pb-2'>
                                                        
                                                        <p className='text-xl 2xl:text-2xl text-black inter-400 mb-6'>What do you want to add?</p>
                                                        <div className='flex items-center flex-wrap md:w-2/3'>
                                                            <div className='customer-radio-sngl w-full md:w-1/3 md:pr-3 mb-5 md:mb-8'>
                                                                <input type="radio" id={`mcq-${index}`} name={`radio-group-${index}`} value="MCQ" checked={assessments[index]["type"] === "MCQ"} onChange={() => handleAssessmentValueChange("MCQ", "type", index)} />
                                                                <label htmlFor={`mcq-${index}`} className=''>Multiple Choice Questions</label>
                                                            </div>
                                                            <div className='customer-radio-sngl w-full md:w-1/3 md:pr-3 mb-5 md:mb-8'>
                                                                <input type="radio" id={`yes_no-${index}`} name={`radio-group-${index}`} value="YES_NO" checked={assessments[index]["type"] === "YES_NO"} onChange={() => handleAssessmentValueChange("YES_NO", "type", index)} />
                                                                <label htmlFor={`yes_no-${index}`}>Yes/No</label>
                                                            </div>
                                                            <div className='customer-radio-sngl w-full md:w-1/3 md:pr-3 mb-5 md:mb-8'>
                                                                <input type="radio" id={`true_false-${index}`} name={`radio-group-${index}`} value="TRUE_FALSE" checked={assessments[index]["type"] === "TRUE_FALSE"} onChange={() => handleAssessmentValueChange("TRUE_FALSE", "type", index)} />
                                                                <label htmlFor={`true_false-${index}`}>True/False</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='lg:px-12 px-6 pb-10'>
                                                    <div className=''>
                                                        {assessments[index]["type"] === 'YES_NO'? (
                                                            <>
                                                                <div className='w-full md:w-4/5 lg:w-1/2'>
                                                                    <div className='form-field mb-6 md:mb-16'>
                                                                        <input type='text' name="primary_text" value={assessments[index]["primary_text"]} onChange={(e) => handleAssessmentValueChange(e.target.value, "primary_text", index)} placeholder='Type the question here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                                                    </div>
                                                                    <p className='text-lg md:text-xl inter-400 text-secondary mb-2'>Select the correct answer</p>
                                                                    <div className='flex items-center flex-wrap mt-4 md:mt-6'>
                                                                        <div className='customer-radio-sngl w-full md:w-1/2 mb-5 md:mb-8'>
                                                                            <input type="radio" id={`yes-${index}`} name={`yes-no-radio-group-${index}`} value={1} checked={assessments[index]["correct_option_no"] === 1} onChange={() => handleAssessmentValueChange(1, "correct_option_no", index)} />
                                                                            <label htmlFor={`yes-${index}`}>Yes</label>
                                                                        </div>
                                                                        <div className='customer-radio-sngl w-full md:w-1/2 mb-5 md:mb-8'>
                                                                            <input type="radio" id={`no-${index}`} name={`yes-no-radio-group-${index}`} value={2} checked={assessments[index]["correct_option_no"] === 2} onChange={() => handleAssessmentValueChange(2, "correct_option_no", index)} />
                                                                            <label htmlFor={`no-${index}`}>No</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                        </>
                                                        ): (
                                                            null
                                                        )}
                                                        {assessments[index]["type"] === 'TRUE_FALSE'? (
                                                            <>
                                                                <div className='w-full md:w-4/5 lg:w-1/2'>
                                                                    <div className='form-field mb-6 md:mb-16'>
                                                                        <input type='text' name="primary_text" value={assessments[index]["primary_text"]} onChange={(e) => handleAssessmentValueChange(e.target.value, "primary_text",  index)} placeholder='Type the question here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                                                    </div>
                                                                    <p className='text-lg md:text-xl inter-400 text-secondary mb-2'>Select the correct answer</p>
                                                                    <div className='flex items-center flex-wrap mt-4 md:mt-6'>
                                                                        <div className='customer-radio-sngl w-full md:w-1/2 mb-5 md:mb-8'>
                                                                            <input type="radio" id={`true-${index}`} name={`true-false-radio-group-${index}`} value={1} checked={assessments[index]["correct_option_no"] === 1} onChange={() => handleAssessmentValueChange(1, "correct_option_no", index)} />
                                                                            <label htmlFor={`true-${index}`}>True</label>
                                                                        </div>
                                                                        <div className='customer-radio-sngl w-full md:w-1/2 mb-5 md:mb-8'>
                                                                            <input type="radio" id={`false-${index}`} name={`true-false-radio-group-${index}`} value={2} checked={assessments[index]["correct_option_no"] === 2} onChange={() => handleAssessmentValueChange(2, "correct_option_no", index)} />
                                                                            <label htmlFor={`false-${index}`}>False</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                        </>
                                                        ): (
                                                            null
                                                        )}
                                                        
                                                        {assessments[index]["type"] === 'MCQ'? (
                                                            <>
                                                                <div className='w-full md:w-4/5 lg:w-1/2'>
                                                                    <div className='form-field mb-6 md:mb-16'>
                                                                        <input type='text' name="primary_text" value={assessments[index]["primary_text"]} onChange={(e) => handleAssessmentValueChange(e.target.value, "primary_text", index)} placeholder='Type the question here...' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                                                    </div>
                                                                    <p className='text-lg md:text-xl inter-400 text-secondary mb-2'>Enter the options</p>
                                                                    <div className='flex items-center flex-wrap mt-4 md:mt-6'>
                                                                        <div className='quiz-ans-sngl flex items-center w-full mb-5 md:mb-8'>
                                                                            <div className='quiz-answer-field flex-1 pl-3'>
                                                                                <input type='text' name={`option1-${index}`} value={assessments[index]["option1"]} onChange={(e) => handleAssessmentValueChange(e.target.value,"option1" , index)} placeholder='Answer Option 01' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                                                            </div>
                                                                        </div>
                                                                        <div className='quiz-ans-sngl flex items-center w-full mb-5 md:mb-8'>
                                                                            <div className='quiz-answer-field flex-1 pl-3'>
                                                                                <input type='text' name={`option2-${index}`} value={assessments[index]["option2"]} onChange={(e) => handleAssessmentValueChange(e.target.value, "option2", index)} placeholder='Answer Option 02' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                                                            </div>
                                                                        </div>
                                                                        <div className='quiz-ans-sngl flex items-center w-full mb-5 md:mb-8'>
                                                                            <div className='quiz-answer-field flex-1 pl-3'>
                                                                                <input type='text' name={`option3-${index}`} value={assessments[index]["option3"]} onChange={(e) => handleAssessmentValueChange(e.target.value, "option3", index)} placeholder='Answer Option 03' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                                                            </div>
                                                                        </div>
                                                                        <div className='quiz-ans-sngl flex items-center w-full mb-5 md:mb-8'>
                                                                            <div className='quiz-answer-field flex-1 pl-3'>
                                                                                <input type='text' name={`option4-${index}`} value={assessments[index]["option4"]} onChange={(e) => handleAssessmentValueChange(e.target.value, "option4", index)} placeholder='Answer Option 04' className='inter-400 bg-[#F8FAFC] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <p className='text-lg md:text-xl inter-400 text-secondary mb-2'>Select the correct answer</p>
                                                                    <div className='flex items-center flex-wrap mt-4 md:mt-6'>
                                                                        <div className='customer-radio-sngl w-1/2 md:w-1/4 mb-5 md:mb-8'>
                                                                            <input type="radio" id={`option1-${index}`} name="mcq1-radio-group" value={1} checked={assessments[index]["correct_option_no"] === 1} onChange={() => handleAssessmentValueChange(1, "correct_option_no", index)} />
                                                                            <label htmlFor={`option1-${index}`}>Option 1</label>
                                                                        </div>
                                                                        <div className='customer-radio-sngl w-1/2 md:w-1/4 mb-5 md:mb-8'>
                                                                            <input type="radio" id={`option2-${index}`} name="mcq1-radio-group" value={2} checked={assessments[index]["correct_option_no"] === 2} onChange={() => handleAssessmentValueChange(2, "correct_option_no", index)} />
                                                                            <label htmlFor={`option2-${index}`}>Option 2</label>
                                                                        </div>
                                                                        <div className='customer-radio-sngl w-1/2 md:w-1/4 mb-5 md:mb-8'>
                                                                            <input type="radio" id={`option3-${index}`} name="mcq1-radio-group" value={3} checked={assessments[index]["correct_option_no"] === 3} onChange={() => handleAssessmentValueChange(3, "correct_option_no", index)} />
                                                                            <label htmlFor={`option3-${index}`}>Option 3</label>
                                                                        </div>
                                                                        <div className='customer-radio-sngl w-1/2 md:w-1/4 mb-5 md:mb-8'>
                                                                            <input type="radio" id={`option4-${index}`} name="mcq1-radio-group" value={4} checked={assessments[index]["correct_option_no"] === 4} onChange={() => handleAssessmentValueChange(4, "correct_option_no", index)} />
                                                                            <label htmlFor={`option4-${index}`}>Option 4</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                        </>
                                                        ): (
                                                            null
                                                        )}

                                                        {assessments[index]["type"] !== undefined ? (
                                                            <div className='flex flex-wrap justify-between mt-12 lg:w-3/4'>
                                                                <div className='w-full md:w-2/5'>
                                                                    <button type="button" onClick={() => addAssessmentData("DRAFT", index)} className='w-full bg-secondary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow mb-5 md:mb-10'>+ Save Question in Draft</button>
                                                                </div>

                                                                <div className='w-full md:w-2/5'>
                                                                    <button type="button" onClick={() => addAssessmentData("PUBLISHED", index)} className='w-full bg-tertiary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow mb-5 md:mb-10'>+ Publish Question</button>
                                                                </div>
                                                                <div className='w-full md:w-2/5'>
                                                                    <button type="button" onClick={() => deleteAssessment(index)} className='w-full bg-primary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow mb-5 md:mb-10'>Delete</button>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            null
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                ) : (
                                    null
                                )}

                                
                            </div>
                        </div>
                    </form>
                </div>
            )}
        </div>
    );
}